import React from 'react';
import PropTypes from 'prop-types';
import { 
  Layout, Menu, Icon, Avatar, Dropdown, Card, Row, Col, Checkbox,
  Button, Spin, Tooltip, Alert, Modal,
} from 'antd';
import DocumentTitle from 'react-document-title';
import { connect } from 'dva';
import { routerRedux , Route, Redirect, Switch } from 'dva/router';
import { ContainerQuery } from 'react-container-query';
import classNames from 'classnames';
import Debounce from 'lodash-decorators/debounce';

import NotFound from '../routes/Exception/404';
import GlobalFooter from '../components/GlobalFooter';
import Link from '../components/Link';
import { getRoutes } from '../utils/utils';
import Authorized from '../utils/Authorized';

import styles from './BasicLayout.less';

const { Header, Sider, Content } = Layout;
const { AuthorizedRoute } = Authorized;
/**
 * 根据菜单取得重定向地址.
 */
const redirectData = [];
const getRedirect = (item) => {
  if (item && item.children) {
    if (item.children[0] && item.children[0].path) {
      redirectData.push({
        from: `/${item.path}`,
        to: `/${item.children[0].path}`,
      });
      item.children.forEach((children) => {
        getRedirect(children);
      });
    }
  }
};

// Allow menu.js config icon as string or ReactNode
//   icon: 'setting',
//   icon: 'http://demo.com/icon.png',
//   icon: <Icon type="setting" />,
const getIcon = (icon) => {
  if (typeof icon === 'string' && icon.indexOf('http') === 0) {
    return <img src={icon} alt="icon" className={styles.icon} />;
  }
  if (typeof icon === 'string') {
    return <Icon type={icon} />;
  }
  return icon;
};

const { SubMenu } = Menu;

const query = {
  'screen-xs': {
    maxWidth: 575,
  },
  'screen-sm': {
    minWidth: 576,
    maxWidth: 767,
  },
  'screen-md': {
    minWidth: 768,
    maxWidth: 991,
  },
  'screen-lg': {
    minWidth: 992,
    maxWidth: 1199,
  },
  'screen-xl': {
    minWidth: 1200,
  },
};

class BasicLayout extends React.PureComponent {
  static childContextTypes = {
    location: PropTypes.object,
    breadcrumbNameMap: PropTypes.object,
  }

  constructor(props) {
    super(props);
    // 把一级 Layout 的 children 作为菜单项

    this.menus = props.menuData || [];
    this.state = {
      openKeys: this.getDefaultCollapsedSubMenus(props),
      modalVisible: false,
      isModalHidden: false,
      isCheckboxDisabled: false,
    };
  }
  getChildContext() {
    const { location, routerData } = this.props;
    return {
      location,
      breadcrumbNameMap: routerData,
    };
  }
  componentDidMount() {
    this.props.dispatch({
      type: 'user/fetchCurrent',
    });
    this.props.dispatch({
      type: 'user/fetchNav',
    });
/*    this.props.dispatch({
      type: 'user/fetchFund',
    }); */
    this.props.dispatch({
      type: 'user/fetchClientId',
    });
    this.props.dispatch({
      type: 'user/fetchInfo',
    });
    this.fetchPopupList();
  }
  componentWillUnmount() {
    this.triggerResizeEvent.cancel();
  }

  onCollapse = (collapsed) => {
    this.props.dispatch({
      type: 'global/changeLayoutCollapsed',
      payload: collapsed,
    });
  }
  onMenuClick = ({ key }) => {
    switch (key) {
      case 'logout':
        this.props.dispatch({ type: 'user/doLogout' })
        break
      default:
        break
    }
  }

  getDefaultCollapsedSubMenus(props) {
    const { location: { pathname } } = props || this.props;
    const snippets = pathname.split('/').slice(1, -1);
    const currentPathSnippets = snippets.map((item, index) => {
      const arr = snippets.filter((_, i) => i <= index);
      return arr.join('/');
    });
    let currentMenuSelectedKeys = [];
    currentPathSnippets.forEach((item) => {
      currentMenuSelectedKeys = currentMenuSelectedKeys.concat(this.getSelectedMenuKeys(item));
    });
    if (currentMenuSelectedKeys.length === 0) {
      return ['dashboard'];
    }
    return currentMenuSelectedKeys;
  }
  getFlatMenuKeys(menus) {
    let keys = [];
    menus.forEach((item) => {
      if (item.children) {
        keys.push(item.path);
        keys = keys.concat(this.getFlatMenuKeys(item.children));
      } else {
        keys.push(item.path);
      }
    });
    return keys;
  }
  getSelectedMenuKeys = (path) => {
    return [path]
    // 可能选中多个吗???
    /*
    const flatMenuKeys = this.getFlatMenuKeys(this.menus);
    if (flatMenuKeys.indexOf(path.replace(/^\//, '')) > -1) {
      return [path.replace(/^\//, '')];
    }
    if (flatMenuKeys.indexOf(path.replace(/^\//, '').replace(/\/$/, '')) > -1) {
      return [path.replace(/^\//, '').replace(/\/$/, '')];
    }
    return flatMenuKeys.filter((item) => {
      const itemRegExpStr = `^${item.replace(/:[\w-]+/g, '[\\w-]+')}$`;
      const itemRegExp = new RegExp(itemRegExpStr);
      return itemRegExp.test(path.replace(/^\//, '').replace(/\/$/, ''));
    });
    */
  }
  /**
  * 判断是否是http链接.返回 Link 或 a
  * Judge whether it is http link.return a or Link
  * @memberof SiderMenu
  */
  getMenuItemPath = (item) => {
    const itemPath = this.conversionPath(item.path);
    const icon = getIcon(item.icon);
    const { target, name, redirectUrl } = item;
    // Is it a http link
    if (redirectUrl) {
      return (
        <a href={item?.redirectUrl} target="_blank" rel="noreferrer">
          {icon}<span>{name}</span>
        </a>
      );
    }
    return (
      <Link
        path={itemPath}
        target={target}
        replace={itemPath === this.props.location.pathname}
        onClick={this.props.isMobile ? () => { this.props.onCollapse(true); } : undefined}
      >
        {icon}<span>{name}</span>
      </Link>
    );
  }
  /**
   * get SubMenu or Item
   */
  getSubMenuOrItem=(item) => {
    if (item.children && item.children.some(child => child.name)) {
      return (
        <SubMenu
          title={
            item.icon ? (
              <span>
                {getIcon(item.icon)}
                <span>{item.name}</span>
              </span>
            ) : item.name
            }
          key={item.key || item.path}
        >
          {this.getNavMenuItems(item.children)}
        </SubMenu>
      );
    } else {
      return (
        <Menu.Item key={item.key || item.path}>
          {this.getMenuItemPath(item)}
        </Menu.Item>
      );
    }
  }
  /**
  * 获得菜单子节点
  * @memberof SiderMenu
  */
  getNavMenuItems = (menusData) => {
    if (!menusData) {
      return [];
    }
    return menusData
      .filter(item => item.name && !item.hideInMenu)
      .map((item) => {
        const ItemDom = this.getSubMenuOrItem(item);
        return this.checkPermissionItem(item.authority, ItemDom);
      })
      .filter(item => !!item);
  }
  // conversion Path
  // 转化路径
  conversionPath=(path) => {
    if (path && path.indexOf('http') === 0) {
      return path;
    } else {
      return `/${path || ''}`.replace(/\/+/g, '/');
    }
  }
  // permission to check
  checkPermissionItem = (authority, ItemDom) => {
    if (this.props.Authorized && this.props.Authorized.check) {
      const { check } = this.props.Authorized;
      return check(
        authority,
        ItemDom
      );
    }
    return ItemDom;
  }

  // 权限begin
  getPageTitle() {
    const { routerData, location } = this.props;
    const { pathname } = location;
    let title = '效果营销平台';
    if (routerData[pathname] && routerData[pathname].name) {
      title = `${routerData[pathname].name} - 效果营销平台`;
    }
    return title;
  }

  fetchPopupRead = () => {
    this.props.dispatch({
      type: 'global/fetchPopupRead',
      payload: {
        code: 1,
      },
    })
  }

  fetchPopupList = () => {
    this.props.dispatch({
      type: 'global/fetchPopupList',
      callback: (res) => {
        if (!res) {
          return;
        }

        if (!res?.find(item => item.code === 1 && item.readed)) {
          this.setState({
            modalVisible: true,
          })
        } else {
          this.setState({
            isModalHidden: true,
          })
        }
      },
    })
  }

  getBashRedirect = () => {
    // According to the url parameter to redirect
    // 这里是重定向的,重定向到 url 的 redirect 参数所示地址
    const urlParams = new URL(window.location.href);

    const redirect = urlParams.searchParams.get('redirect');
    // Remove the parameters in the url
    if (redirect) {
      urlParams.searchParams.delete('redirect');
      window.history.replaceState(null, 'redirect', urlParams.href);
    } else {
      return '/home';
    }
    return redirect;
  }
  handleMenuCollapse = (collapsed) => {
    this.props.dispatch({
      type: 'global/changeLayoutCollapsed',
      payload: collapsed,
    });
  }
  // 权限end

  handleOpenChange = (openKeys) => {
    const lastOpenKey = openKeys[openKeys.length - 1];
    const isMainMenu = this.menus.some(
      item => lastOpenKey && (item.key === lastOpenKey || item.path === lastOpenKey)
    );
    this.setState({
      openKeys: isMainMenu ? [lastOpenKey] : [...openKeys],
    });
  }
  toggle = () => {
    const { collapsed } = this.props;
    this.props.dispatch({
      type: 'global/changeLayoutCollapsed',
      payload: !collapsed,
    });
    this.triggerResizeEvent();
  }
  @Debounce(600)
  triggerResizeEvent() { // eslint-disable-line
    const event = document.createEvent('HTMLEvents');
    event.initEvent('resize', true, false);
    window.dispatchEvent(event);
  }

  cancelTest = () => {
    alert('测试cancel')
  }

  confirmTest = () => {
    alert('测试confirm')
  }

  getQueryString = (name, search) => {
    search = search ||  window.location.search.substr(1) || window.location.hash.split("?")[1];
    const reg = new RegExp(`(^|&)${ name }=([^&]*)(&|$)`);
    const r = search ? search.match(reg): '';
    if (r != null) return  unescape(r[2]); return null;
  }

  handleModalOk = () => {
    this.setState({
      modalVisible: false,
    })
    if (this.state.isModalHidden) {
      this.fetchPopupRead();
    }
  }

  handleModalCancel = () => {
    this.handleModalOk();
  }

  handleCreateAd = () => {
    this.props.dispatch({
      type: "promote/checkAdCountLimit",
    }).then((res) => {
      if (res && res.exceeded) {
        Modal.warning({
          title: '提示',
          content: '当前账户广告单数量超过300条，无法开启/新建广告单',
          okText: '我知道了',
          centered: true,
        });
        return;
      }
      this.props.dispatch(routerRedux.push({
        pathname: '/promote/create-step',
        search: 'mode=create',
      }));
    }).catch(() => {
      // 接口异常时不阻塞，允许正常跳转
      this.props.dispatch(routerRedux.push({
        pathname: '/promote/create-step',
        search: 'mode=create',
      }));
    });
  }
  
  render() {
    const proxyId = this.getQueryString('proxyId')
    const userData = JSON.parse(sessionStorage.getItem('userInfo'))
    // console.log('proxyId',proxyId)
    if (Boolean(Number(proxyId)) && !userData) {
      this.props.dispatch({
        type: 'user/proxyReq',
        payload: {
          proxyId,
          proxyPlatform: 'sponsor',
        },
      })
    }else if (!userData) {
      try {
        this.props.dispatch(routerRedux.push('/user/login'));
      } catch (e) {
        this.props.dispatch(routerRedux.push('/user/login'));
      }
    }

    const { currentUser, collapsed, routerData, match, location } = this.props;
    const { pathname } = location;

    const bashRedirect = this.getBashRedirect();

    const userInfo = () => {
      const { sponsorId, sponsorProductName, company, avatar  } = currentUser || {}
      const { fundAccountName } = this.props.sponsorInfo || {};

      return (
        sponsorId
          ? (
            <Dropdown
              overlay={(
                <Menu className={styles.menu} selectedKeys={[]} onClick={this.onMenuClick}>
                  {/* <Menu.Item><Icon type="user" />个人中心</Menu.Item>
                  <Menu.Item><Icon type="setting" />设置</Menu.Item>
                  <Menu.Divider /> */}
                  <Menu.Item key="account"><Link path="/account/info"><Icon type="user" />账户信息</Link></Menu.Item>
                  <Menu.Item key="logout"><Icon type="logout" />退出登录</Menu.Item> 
                </Menu>
              )}
            >
              <span className={`${styles.action} ${styles.account}`}>
                <Avatar size="small" className={styles.avatar} {...(avatar ? { src: avatar } : { icon: 'user' })} />
                <span>
                  {`${fundAccountName || sponsorProductName || company} (ID: ${sponsorId})`}
                </span>
                <Icon className={styles.drop} type="caret-down" />
              </span>
            </Dropdown>
          )
          : <Spin size="small" style={{ marginLeft: 8 }} />
      )
    }
    const { openKeys } = this.state;
    // Don't show popup menu when it is been collapsed
    const menuProps = collapsed ? {} : {
      openKeys,
    };
    // if pathname can't match, use the nearest parent's key
    let selectedKeys = this.getSelectedMenuKeys(pathname);
    if (!selectedKeys.length) {
      selectedKeys = [openKeys[openKeys.length - 1]];
    }

    const certificateStatus = ((this.props.sponsorInfo || {}).certificateAudit || {}).code // 审核状态
    const alertMessage = certificateStatus === 601 // 过期
      ? '广告主审核状态已过期，请检查广告主审核信息，并重新提交审核'
      : null
    const offsetTop = `${(64 + 24 + 16 * 2 + 21) + (alertMessage ? 37 : 0)}px`

    const layout = (
      <Layout>
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          breakpoint="md"
          onCollapse={this.onCollapse}
          width={220}
          className={styles.sider}
        >
          <div className={styles.logo}>
            <Link path="/">
              <img src={require('../assets/icon.png')} alt="logo" />
              <h1>效果营销平台</h1>
            </Link>
          </div>
          <Menu
            theme="dark"
            mode="inline"
            {...menuProps}
            onOpenChange={this.handleOpenChange}
            selectedKeys={selectedKeys}
            style={{ margin: '16px 0', width: '100%' }}
          >
            {this.getNavMenuItems(this.menus)}
          </Menu>
        </Sider>
        <Layout className={styles.layout}>
          <Header className={styles.header}>
            <Icon
              className={styles.trigger}
              type={collapsed ? 'menu-unfold' : 'menu-fold'}
              onClick={this.toggle}
            />
            <div
              className={styles.noticeText}
              onClick={() => {
              this.setState({
                modalVisible: true,
              })
            }}
            >
              【重要！！】麦穗广告金更新体系通知
            </div>
            <div className={styles.right}>
              {userInfo()}
              {/* <a className={styles.help + " " + styles.divide}>
                <Tooltip title="帮助中心">
                  <Icon type="question-circle-o" />
                </Tooltip>
              </a> */}
              <span className={styles.divide} />
              <Button type="primary" icon="plus" onClick={this.handleCreateAd}>新建广告</Button>
            </div>
          </Header>
          {alertMessage && <Alert className={styles.alert} message={alertMessage} banner />}
          <Content className={styles.content} style={{ '--offset-top': offsetTop }}>
            <Switch>
              {
                redirectData.map(item =>
                  <Redirect key={item.from} exact from={item.from} to={item.to} />
                )
              }
              {
                getRoutes(match.path, routerData).map(item =>
                  (
                    <AuthorizedRoute
                      key={item.key}
                      path={item.path}
                      component={item.component}
                      exact={item.exact}
                      authority={item.authority}
                      redirectPath="/exception/403"
                    />
                  )
                )
              }
              <Redirect exact from="/" to={bashRedirect} />
              <Route render={NotFound} />
            </Switch>
            <GlobalFooter
              className="global-footer"
              copyright={
                <div>
                  Copyright <Icon type="copyright" /> 网易公司版权所有©1997-至今 ICP证浙B2-201611021
                </div>
              }
            />
          </Content>
        </Layout>
        <Modal
          width={950}
          title="麦穗广告金体系更新通知"
          visible={this.state.modalVisible}
          onOk={this.handleModalOk}
          onCancel={this.handleModalCancel}
        >
          <div className={styles.modalContent}>
            <div className={styles.modalTopContent}>
              <p className={styles.modalP}>尊敬的麦穗广告主您好：</p>
              <p className={styles.modalP}>3/10号将上线新版麦穗广告金体系，重要改动点如下：</p>
              <ul className={styles.modalUl}>
                <li className={styles.modalLi}>
                  <p>
                    麦穗当前体系的现金、虚拟金改版为非赠款、赠款与赔付，原有的赔付与赠款在平台更新后会自动刷入对应款项，账户总余额不发生改变；平台后续的年框返货、新客激励与ocpx赔付等款项会打入相应的资金类型
                  </p>
                  <p>
                    <img src={require('../assets/modal-img-1.png')} width={800} alt='' />
                  </p>
                </li>
                <li className={styles.modalLi}>
                  <p>
                    资金类型的消耗优先级为赔付{'>'}赠款{'>'}非赠款，但当日赔付+赠款消耗金额最高等于非赠款消耗金额，例：
                  </p>
                  <ul className={styles.modalUl}>
                    <p>
                      <li className={styles.modalLi}>
                        账户非赠款余额1000、赠款余额800、赔付余额200；当日广告消耗800，最终扣款应为赔付消耗200，赠款消耗200，非赠款消耗400（即资金类型优先级为赔付{'>'}赠款{'>'}非赠款，且赔付+赠款消耗金额最高等于非赠款消耗金额）
                      </li>
                    </p>
                  </ul>
                </li>
                <li className={styles.modalLi}>
                  <p>
                    mapi麦穗开放平台中广告主账户余额信息与查询账户流水接口将不再提供现金/虚拟金字段，改为相应的非赠款、赠款与赔付字段，详情可见开放平台文档最底部，老字段在新字段上线后一周后不再维护，请及时更换接口字段，以防数据拉取报错
                  </p>
                  <a target='_blank' href='https://maisui.netease.com/openapi/#/document' rel="noreferrer">https://maisui.netease.com/openapi/#/document</a>
                  <p>
                    <img src={require('../assets/modal-img-2.png')} width={800} alt='' />
                  </p>
                  <p>
                    <img src={require('../assets/modal-img-3.png')} width={800} alt='' />
                  </p>
                </li>
              </ul>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: 20 }}>
              <Checkbox
                value={this.state.isModalHidden}
                disabled={this.state.isCheckboxDisabled}
                onChange={(e) => {
                this.setState({ isModalHidden: e.target.checked })
              }}
              >
                不再展示该弹窗
              </Checkbox>
            </div>
          </div>
        </Modal>
      </Layout>
    );

    return (
      <DocumentTitle title={this.getPageTitle()}>
        <ContainerQuery query={query}>
          {params => <div className={classNames(params)}>{layout}</div>}
        </ContainerQuery>
      </DocumentTitle>
    );
  }
}

export default connect(({ global, user }) => ({
  sponsorInfo: user.sponsorInfo,
  currentUser: JSON.parse(sessionStorage.getItem('userInfo')),
  ...global,
}))(BasicLayout);
